import { _, helpers, ts } from '_core';

import { DraftParams } from './types';

export const formatSeriesName = (key: string, baskets: { handle: string; name?: string }[]) => {
  const currentBasket = baskets.find((b) => b.handle == key);
  if (currentBasket) return currentBasket.name || currentBasket.handle;

  return key;
};

export const prepareLinearData = (
  localData: ts.types.widgets.TableData,
  isPortfolio = false,
  baskets: { handle: string; name?: string }[] = []
) => {
  const newData = localData.map((el) => {
    const newRow = {
      date: el.date,
    } as ts.types.widgets.TableData[number];

    Object.keys(el).forEach((key) => {
      if (key !== 'date') {
        let entityKey = key.split('-')[0];
        let historyType = '';
        Object.values(ts.enums.HISTORY_ENUM_EXTENDED).forEach((historyEnum) => {
          if (entityKey.startsWith(historyEnum)) {
            historyType = `${historyEnum}_`;
            entityKey = entityKey.replace(historyType, '');
          }
        });
        const formattedKey = `${historyType}${formatSeriesName(entityKey, baskets)}`;

        if (isPortfolio) {
          if (key.includes('portfolio_returns')) newRow[formattedKey] = el[key];
        } else if (!key.includes('portfolio_returns')) newRow[formattedKey] = el[key];
      }
    });
    return newRow;
  });

  return newData;
};

export const validate = (params: DraftParams) => helpers.validations.validBasketCompare(params);

export const formatData = (
  data: ts.types.widgets.TableData,
  periods: ts.enums.PERIOD_ENUM[]
): ts.types.widgets.TableData => {
  const groupedData = _.groupBy(data, 'end_date');
  const series = new Set(data.map((item) => item.backtest_handle));

  const entriesByEndDate = _.map(groupedData, (items, date) => {
    const formattedEntry: ts.types.widgets.TableData[number] = { date };

    series.forEach((serie) => {
      const item = items.find((i) => i.backtest_handle === serie) ?? {};
      const backtest_handle = serie;

      const { return: portfolio_returns, benchmark_returns, active_returns } = item;

      formattedEntry[`${backtest_handle}-portfolio_returns`] = portfolio_returns ?? null;
      formattedEntry[`${backtest_handle}-benchmark_returns`] = benchmark_returns ?? null;
      formattedEntry[`${backtest_handle}-active_returns`] = active_returns ?? null;

      _.without(periods, ts.enums.PERIOD_ENUM.FULL).forEach((history) => {
        formattedEntry[`${history}_${backtest_handle}-active_returns`] = item?.[`${history}_active_returns`] ?? null;
        formattedEntry[`${history}_${backtest_handle}-benchmark_returns`] =
          item?.[`${history}_benchmark_returns`] ?? null;
        formattedEntry[`${history}_${backtest_handle}-portfolio_returns`] = item?.[`${history}_return`] ?? null;
      });
    });
    return formattedEntry;
  });

  return _.sortBy(entriesByEndDate, 'date');
};
